import { PublicClientApplication } from '@azure/msal-browser'

/* eslint-disable no-undef */

const clientID = process.env.REACT_APP_CLIENT_ID
const tenantID = process.env.REACT_APP_TENANT_ID

const msalConfig = {
  auth: {
    clientId: clientID,
    authority: `https://login.microsoftonline.com/${tenantID}`,
    redirectUri: '/msauthenticate',
    post_logout_redirect_uri: '/msauthenticate',
    navigateToLoginRequestUrl: false,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
